import React from 'react';

const SvgOther22 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 16 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M9 9h5v3H9zM7 7H2V4h5zm8.5-3H9a2 2 0 0 0-2-2H2V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v19a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V12h5a2 2 0 0 0 2 2h6.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgOther22 svgRef={ref} {...props} />);
export default ForwardRef;
